import { render, staticRenderFns } from "./SaDistrDestMultipleInput.vue?vue&type=template&id=156b4ba8&"
import script from "./SaDistrDestMultipleInput.vue?vue&type=script&lang=js&"
export * from "./SaDistrDestMultipleInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports